import React from 'react'
import { SVGIconProps } from '../types'
const SvgEject = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 24V0h24v24z" />
    <path d="M5 17h14v2H5zm7-12L5.33 15h13.34z" />
  </svg>
)
export default SvgEject
